import { showHttpError } from '@calendly/alert'
import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'

const createExport = (params = {}) => httpRequest({
  url: '/api/organization/invitations/export',
  method: 'POST',
  params
})

const invitationsExportSelector = (state) => state.invitationsExport
export const confirmationOpenSelector = createSelector(invitationsExportSelector, ({ confirmationOpened }) => confirmationOpened)
export const isLoadingSelector = createSelector(invitationsExportSelector, ({ exportProcessing }) => exportProcessing)

export const createDelayedExport = createAsyncThunk(
  'invitationsExport/create',
  async (params = {}, { dispatch, rejectWithValue }) => {
    const [success, response] = await createExport(params)

    if (success && response.location === 'inline' && !!response.url) {
      window.open(response.url, '_self')
      return rejectWithValue()
    }

    if (!success) {
      dispatch(showHttpError(response))
      return rejectWithValue()
    }

    return response
  }
)

const initialState = {
  confirmationOpened: false,
  exportProcessing: false
}

const slice = createSlice({
  name: 'invitationsExport',
  initialState,
  reducers: {
    closeConfirmation: (state) => {
      state.confirmationOpened = false
    }
  },
  extraReducers: (builder) => {
    builder.addCase(createDelayedExport.fulfilled, (state) => {
      state.confirmationOpened = true
      state.exportProcessing = false
    })
    builder.addCase(createDelayedExport.pending, (state) => {
      state.exportProcessing = true
    })
    builder.addCase(createDelayedExport.rejected, (state) => {
      state.exportProcessing = false
    })
  }
})

export const { reducer, actions: { closeConfirmation } } = slice
